import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#F6F5F2]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1A3626] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="about-title">
          About Us
        </h1>

        <div className="bg-white rounded-lg p-6 sm:p-8 shadow-sm mb-6">
          <div className="flex items-center justify-center mb-8">
            <img src="/logo-new.png" alt="Krishna Machinery Stores" className="h-32 sm:h-40 object-contain" />
          </div>
          
          <div className="prose max-w-none">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Welcome to <strong className="text-[#1A3626]">Krishna Machinery Stores</strong> — your trusted partner for agricultural & industrial machinery solutions. We are committed to providing quality equipment to support farmers, industries, and businesses across the region.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              With an extensive range of products including power tools, engine parts, agricultural implements, industrial supplies, construction equipment, and machinery accessories, we serve both the agricultural and industrial communities with dedication and expertise.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg p-6 sm:p-8 shadow-sm">
          <h2 className="text-2xl font-semibold text-[#1A3626] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Contact Information
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-start gap-4" data-testid="contact-address">
              <MapPin className="h-6 w-6 text-[#C05A3E] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-[#1A3626] mb-1">Address</h3>
                <p className="text-gray-700">
                  C.P.Towers, near Apurvam Plywood,<br />
                  Malegaon Motor Stand, Panchavati,<br />
                  Nashik - 422003
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-testid="contact-phone">
              <Phone className="h-6 w-6 text-[#C05A3E] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-[#1A3626] mb-1">Phone</h3>
                <p className="text-gray-700">
                  Mobile: <a href="tel:9607515786" className="text-[#C05A3E] hover:underline">9607515786</a>
                  <br />
                  Tel: <a href="tel:02532515786" className="text-[#C05A3E] hover:underline">0253-2515786</a>
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-testid="contact-email">
              <Mail className="h-6 w-6 text-[#C05A3E] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-[#1A3626] mb-1">Email</h3>
                <p className="text-gray-700 break-all text-sm sm:text-base">
                  <a href="mailto:krishnamachinerystores2@gmail.com" className="text-[#C05A3E] hover:underline">
                    krishnamachinerystores2@gmail.com
                  </a>
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Clock className="h-6 w-6 text-[#C05A3E] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-[#1A3626] mb-1">Business Hours</h3>
                <p className="text-gray-700">
                  Monday - Saturday: 10:00 AM - 8:00 PM<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-[#1A3626] text-white rounded-lg p-6 text-center">
          <p className="text-lg">
            For bulk orders or special inquiries, please contact us directly.
          </p>
        </div>

        <div className="bg-white rounded-lg p-6 sm:p-8 shadow-sm mt-6" data-testid="google-maps-section">
          <h2 className="text-2xl font-semibold text-[#1A3626] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Find Us on Map
          </h2>
          <div className="w-full rounded-lg overflow-hidden" style={{ height: '350px' }}>
            <iframe
              title="Krishna Machinery Stores Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.0!2d73.7898!3d19.9975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDU5JzUxLjAiTiA3M8KwNDcnMjMuMyJF!5e0!3m2!1sen!2sin!4v1700000000000&q=Shop+No+A-110+Malegaon+Stand+Panchavati+Nashik+Maharashtra+422003"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="google-maps-iframe"
            />
          </div>
          <p className="text-sm text-gray-500 mt-3 text-center">
            Shop No. A-110, Malegaon Stand, Panchavati, Nashik, Maharashtra 422003
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;